import React from 'react'

export default function EditImg() {
      return (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9576 3.55078H3.95764C3.42721 3.55078 2.9185 3.76149 2.54343 4.13657C2.16836 4.51164 1.95764 5.02035 1.95764 5.55078V19.5508C1.95764 20.0812 2.16836 20.5899 2.54343 20.965C2.9185 21.3401 3.42721 21.5508 3.95764 21.5508H17.9576C18.4881 21.5508 18.9968 21.3401 19.3719 20.965C19.7469 20.5899 19.9576 20.0812 19.9576 19.5508V12.5508" stroke="#008744" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.4576 2.05101C18.8555 1.65318 19.395 1.42969 19.9576 1.42969C20.5203 1.42969 21.0598 1.65318 21.4576 2.05101C21.8555 2.44883 22.079 2.9884 22.079 3.55101C22.079 4.11362 21.8555 4.65318 21.4576 5.05101L11.9576 14.551L7.95764 15.551L8.95764 11.551L18.4576 2.05101Z" stroke="#008744" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>        
      )
    }
   
